import { render, staticRenderFns } from "./facebook-clone.vue?vue&type=template&id=5b44e20c&"
import script from "./facebook-clone.vue?vue&type=script&lang=js&"
export * from "./facebook-clone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports